module.exports = __webpack_public_path__ + "static/redux-8251fe76d7487a28b07603515b300964.png";